import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// Cycle 109 v2 Sprint 1: canonical design tokens after index.css so theme-dark/theme-light
// selectors drive --bg/--fg/--sig-* values. legacy-aliases.css maps --cd-* onto canonical.
import './styles/design-system.css';
import './styles/legacy-aliases.css';
import { applyDemoModeQueryParam } from './demo/demoMode';

// Bootstrap canonical theme class + restore persisted theme before first paint.
// Persistence key per cycle-109 v2 AC-1.1.b. The legacy `.light` class (gating --e-*
// overrides in index.css) is set alongside `theme-light` so both namespaces switch atomically.
(() => {
  try {
    const stored = window.localStorage.getItem('echelon.workspace.theme');
    const initial = stored === 'light' ? 'light' : 'dark';
    const root = document.documentElement;
    root.classList.remove('theme-dark', 'theme-light');
    root.classList.add(initial === 'light' ? 'theme-light' : 'theme-dark');
    if (initial === 'light') {
      root.classList.add('light');
    } else {
      root.classList.remove('light');
    }
  } catch {
    document.documentElement.classList.add('theme-dark');
  }
})();

// Apply demo mode query param before rendering
applyDemoModeQueryParam();

// RouterProvider is already used in App.tsx, so we don't need BrowserRouter here
const root = ReactDOM.createRoot(document.getElementById('root')!);
if (import.meta.env.DEV) {
  // Development: Render without StrictMode to avoid double renders
  root.render(<App />);
} else {
  // Production: Use StrictMode
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
